<script setup>
const list = ref([
          {
          haveDate: '2023',
          date: '2023.03',
          date_us: 'Mar 2023',
          content_us:'Forthright Securities participated in the HK IPO of JF Wealth Holdings Ltd as a Joint Bookrunner and Joint Lead Manager',
          content: '方德证券作为联席帐簿管理人及联席牵头经办人参与九方财富港股IPO',
          content_hk: '方德證券作為聯席帳簿管理人及聯席牽頭經辦人蔘與九方財富港股IPO'
        },
        {
          haveDate: '2021',
          date: '2021.07',
          date_us: 'Jul 2021',
          content_us:
            'Forthright Securities was invited to participate in the 10th CFS China Finance Summit - 2021 Sustainable Business Conference, sharing and discussing the promotion of digital transformation of securities companies, and won the "2021 Financial Technology Influential Brand" award',
          content: '方德证券受邀参加第十届CFS中国财经峰会暨2021可持续商业大会，分享探讨推进券商数字化转型议题，荣获“2021金融科技影响力品牌”奖项',
          content_hk: '方德證券受邀參加第十屆CFS中國財經峰會暨2021可持續商業大會，分享探討推進券商數位化轉型議題，榮獲“2021金融科技影響力品牌”獎項'
        },
        {
          date: '2021.04',
          date_us: 'Apr 2021',
          content_us:
            'Forthright Securities was invited to participate in the Refinitiv Market Outlook Forum to explore the opportunities and risks of overseas investment in 2021',
          content: '方德证券受邀参加Refinitiv市场展望论坛，共探2021海外投资机遇与风险',
          content_hk: '方德證券受邀參加Refinitiv市場展望論壇，共探2021海外投資機遇與風險'
        },

        {
          date: '2021.03',
          date_us: 'Mar 2021',
          content_us: 'Reached a cooperation with CSOP Asset Management Limited',
          content: '与南方东英资产管理有限公司达成合作',
          content_hk: '與南方東英資產管理有限公司達成合作 '
        },
        {
          date: '2021.03',
          date_us: 'Mar 2021',
          content_us: 'Forthright Securities second debuted on the Nasdaq screen in Times Square, New York, US ',
          content: '方德证券二次亮相美国纽约时代广场纳斯达克大屏',
          content_hk: '方德證券二次亮相美國紐約時代廣場納斯達克大屏'
        },

        {
          date: '2021.01',
          date_us: 'Jan 2021',
          content_us: 'Forthright Securities participated in the HK IPO of Modern Chinese Medicine Group as an underwriter ',
          content: '方德证券作为承销商参与现代中药集团港股IPO ',
          content_hk: '方德證券作為承銷商參與現代中藥集團港股IPO '
        },

        {
          haveDate: '2020',
          date: '2020.11',
          date_us: 'Nov 2020',
          content_us: 'Started International placement services',
          content: '开通国际配售服务',
          content_hk: '開通國際配售服務'
        },

        {
          haveDate: '2019',
          date: '2019.09',
          date_us: 'Sep 2019',
          content_us: 'Forthright Securities participated in the HK IPO of Weihai City Commercial Bank Co., Ltd. ("Weihai Bank") as the underwriter',
          content: '方德证券作为承销商参与威海市商业银行股份有限公司（简称"威海银行"）港股IPO',
          content_hk: '方德證券作為承銷商參與威海市商業銀行股份有限公司（簡稱"威海銀行"）港股IPO'
        },
        {
          date: '2019.09',
          date_us: 'Sep 2019',
          content_us: 'Forthright Securities Participated in the HK IPO of China Feihe as an underwriter',
          content: '方德证券作为承销商参与中国飞鹤港股IPO',
          content_hk: '方德證券作為承銷商參與中國飛鶴港股IPO'
        },

        {
          date: '2019.03',
          date_us: 'Mar 2019',
          content_us: 'Forthright (Hong Kong) granted the SFC Type 2 and Type 5 Regulated Activities License',
          content: '方德（香港）获发香港证监会第2类、第5类受规管活动牌照',
          content_hk: '方德（香港）獲發香港證監會第2類、第5類受規管活動牌照'
        },

        {
          haveDate: '2018',
          date: '2018.08',
          date_us: 'Aug 2018',
          content_us: 'Forthight Securities first debuted on the Nasdaq screen in Times Square, New York, U.S.  ',
          content: '方德证券首次亮相美国纽约时代广场纳斯达克大屏',
          content_hk: '方德證券首次亮相美國紐約時代廣場納斯達克大屏 '
        },

        {
          haveDate: '2017',
          date: '2017.10',
          date_us: 'Oct 2017',
          content_us: 'Forthright (Hong Kong) granted the SFC Type 4 Regulated Activity',
          content: '方德（香港）获发香港证监会第4类受规管活动牌照',
          content_hk: '方德（香港）獲發香港證監會第4類受規管活動牌照'
        },

        {
          date: '2017.07',
          date_us: 'Jul 2017',
          content_us:
            'Forthright (Hong Kong) officially commenced business as an emerging Internet broker. Forthright (Hong Kong) focuses on providing investment services in Hong Kong and US stock trading for global Chinese investors',
          content: '方德（香港）正式鸣锣开业。作为新兴互联网券商平台，方德专注于为全球华人投资者提供港美股交易的投资服务',
          content_hk: '方德（香港）正式鳴鑼開業。作為新興互聯網券商平台，方德專注於為全球華人投資者提供港美股交易的投資服務'
        },

        {
          date: '2017.06',
          date_us: 'Jun 2017',
          content_us: "Forthright (Hong Kong)'s mobile application, namely方德港美股APP, first launched",
          content: '方德港美股APP首发',
          content_hk: '方德港美股APP首發'
        },

        {
          haveDate: '2016',
          date: '2016.05',
          date_us: 'May 2016',
          content_us:
            "Forthright (Hong Kong) has been granted the SFC's Type 1 Regulated Activity and obtained market access qualifications. Forthright (Hong Kong) becoming a licensed corporation recognized by the SFC with CE No. BGP713.",
          content: '方德（香港）获发香港证监会第1类受规管活动牌照，获得市场准入资格，是香港证监会认可的持牌法团（中央编号BGP713）',
          content_hk: '方德（香港）獲發香港證監會第1類受規管活動牌照，獲得市場准入資格，是香港證監會認可的持牌法團（中央編號BGP713）'
        },

        {
          haveDate: '2015',
          date: '2015.08',
          date_us: 'Aug 2015',
          content_us: 'Forthright (Hong Kong) is established.',
          content: '方德（香港）正式成立',
          content_hk: '方德（香港）正式成立'
        }
      ])
const lang = useI18n().locale.value;
</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
    <div   class="about-warp__right--title">{{ $t('fdlc') }}</div>
    <div class="about-warp__right--content course-box">
      <template v-for="(item, index) in list">
        <div v-if="item.haveDate" class="timeline-year">
          <p>{{ item.haveDate }}</p>
          <!-- <p>2019</p> -->
        </div>
        <div class="timeline-item">
          <p class="date" v-if="lang == 'en'">{{ item.date_us }}</p>
          <p class="date" v-if="lang != 'en'">{{ item.date }}</p>
          <p class="text" v-if="lang == 'en'">{{ item.content_us }}</p>
          <p class="text" v-else-if="lang == 'hk'">{{ item.content_hk }}</p>
          <p class="text" v-else>{{ item.content }}</p>
        </div>
      </template>
      <!-- <div class="timeline-item">
        <p class="date">{{ $t('2019n9y') }}</p>
        <p class="text">
          {{ $t('fdzqzwwydhlwqscylzgfhdggipofxyw') }}
        </p>
      </div>

      <div class="timeline-item">
        <p class="date">{{ $t('2019n3y') }}</p>
        <p class="text">
          {{ $t('fdxghfxgzjhd2ld5lsgghdpz') }}
        </p>
      </div>
      <div class="timeline-year">
        <p>2018</p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2018n11y') }}</p>
        <p class="text">
          {{ $t('zysxzshejzsgkhck') }}
        </p>
      </div>
      <div class="timeline-year">
        <p>2017</p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2017n12y') }}</p>
        <p class="text">
          {{ $t('hsgtbxjysx') }}
        </p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2017n11y') }}</p>
        <p class="text">
          {{ $t('bzjywqmsx') }}
        </p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2017n10y') }}</p>
        <p class="text">
          {{ $t('fdxghfxgzjhd4lsgghdpz') }}
        </p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2017n8y') }}</p>
        <p class="text">
          {{ $t('ggdxsx') }}
        </p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2017n7y') }}</p>
        <p class="text">
          {{ $t('fdxgzsmlkyzwxxhlwqsptfdzzywqqhrtzztggmgjydtzfw') }}
        </p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2017n6y') }}</p>
        <p class="text">
          {{ $t('fdgmgappsf') }}
        </p>
      </div>
      <div class="timeline-year">
        <p>2016</p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2016n5y') }}</p>
        <p class="text">
          {{ $t('fdxghfxgzjhd1lsgghdpzhdsczrzgsxgzjhrkdcpftzybhbgp713') }}
        </p>
      </div>
      <div class="timeline-year">
        <p>2015</p>
      </div>
      <div class="timeline-item">
        <p class="date">{{ $t('2015n8y') }}</p>
        <p class="text">
          {{ $t('fdxgzscl') }}
        </p>
      </div> -->
    </div>
  </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";

@media screen and (max-width: 420px) {
  body {
    .course-box {
      margin: 10px 20px !important;
    }
  }
}

.course-box {
  border-left: 1px solid #D54745;
  border-image: linear-gradient(to top, #D54745 95%, transparent) 0 0 0 100%;
  border-right: none;
  margin-top: 12px;

  .timeline-item {
    position: relative;
    margin-bottom: 33px;

    .date {
      padding-left: 34px;
      color: #1d2228;
      margin-bottom: 9px;
      position: relative;
      .font-size-line(14, 20, 600);

      &::after {
        content: '';
        width: 8px;
        height: 8px;
        display: block;
        position: absolute;
        border-radius: 50%;
        left: 0%;
        top: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid #d54745;
        background: #ffffff;
      }

      &::before {
        width: 8px;
        height: 1px;
        position: absolute;
        left: 4px;
        top: 10px;
        content: '';
        background: red;
      }
    }

    .text {
      padding-left: 34px;
      color: #61676b;
      .font-size-line(15, 21);
    }
  }

  .timeline-year {
    width: 80px;
    height: 20px;
    color: #ffffff;
    margin-left: -15px;
    margin-bottom: 33px;
    z-index: 10;
    .font-size-line(14, 20);
    background: #ffffff;

    p {
      padding-left: 10px;
      background: linear-gradient(90deg, #d54745 0%, rgba(213, 71, 69, 0) 100%);
    }
  }
}
</style>
